import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'lib-event-log-page-not-found',
    imports: [CommonModule],
    templateUrl: './event-log-page-not-found.component.html',
    styleUrl: './event-log-page-not-found.component.scss'
})
export class EventLogPageNotFoundComponent {}
